import Skeleton from '../skeleton/Skeleton';
import ContactsTableSkeleton from './ContactsTableSkeleton';
import { StyledContacts } from './Contacts.styles';

/**
 * The whole page's shape, shown until the first page of contacts (and the
 * summary behind the error notice) has arrived. It uses the page's own
 * wrapper and classes, so nothing moves when the real page takes its place.
 */
const ContactsSkeleton = () => (
  <StyledContacts id="leads-module" aria-busy="true">
    <main className="contacts-main">
      <section className="contacts-header">
        <div className="header-top">
          <div className="header-copy">
            <Skeleton width={150} height={28} radius="8px" resp />
            <Skeleton width={560} height={14} radius="6px" margin="10px 0 0" resp />
            <Skeleton width={320} height={14} radius="6px" margin="6px 0 0" resp />
          </div>
          <div className="header-actions">
            <Skeleton width={180} height={36} radius="14px" resp />
            <Skeleton width={96} height={36} radius="14px" resp />
            <Skeleton width={140} height={36} radius="14px" resp />
          </div>
        </div>

        <div className="network-grid">
          {[0, 1, 2].map(key => (
            <div key={key} className="network-card">
              <div className="network-card-top">
                <Skeleton width={28} height={28} radius="10px" resp />
                <Skeleton width={150} height={14} radius="6px" resp />
              </div>
              <Skeleton width={200} height={12} radius="6px" margin="10px 0 0" resp />
              <Skeleton width={96} height={12} radius="6px" margin="12px 0 0" resp />
            </div>
          ))}
        </div>

        <div className="filter-bar">
          <Skeleton width={120} height={36} radius="14px" resp />
          <Skeleton width={150} height={36} radius="14px" resp />
          <div className="filter-right">
            <Skeleton width={280} height={36} radius="14px" resp />
            <Skeleton width={90} height={36} radius="14px" resp />
          </div>
        </div>
      </section>

      <section className="table-card">
        <div className="table-main">
          <div className="table-head-bar">
            <Skeleton width={110} height={16} radius="6px" resp />
            <Skeleton width={150} height={32} radius="12px" resp />
          </div>
          <ContactsTableSkeleton />
        </div>
      </section>
    </main>
  </StyledContacts>
);

export default ContactsSkeleton;
